import { player } from "./selectors"
import fullscreenAPI from "../utils/fullscreen-api"

export const isPlayerInCSSFullscreen = () => {
  return player.hasClass("fullscreen-css")
}

export const isPlayerInFullscreen = () => {
  return fullscreenAPI.isFullscreen || isPlayerInCSSFullscreen()
}
